module.exports = __webpack_public_path__ + "static/og-8aabf80f2e3a1630fe54fa79d12700bc.png";